import type { BreadcrumbSegment } from '../../../lib/breadcrumbs';
import { resolveVisibleNavigationGroups, shigoNavigationGroups } from '../shigo-navigation.config';
import type { ShigoNavigationAccessContext } from '../shigo-navigation.types';

export function resolveSectionBreadcrumbs(
  crumbs: BreadcrumbSegment[],
  context: ShigoNavigationAccessContext,
  params: Record<string, string | undefined>,
): BreadcrumbSegment[] {
  const groups = resolveVisibleNavigationGroups(shigoNavigationGroups, context);
  const scopedPath = (path: string) =>
    path.replace(/\$([^/]+)/g, (_, key: string) => encodeURIComponent(params[key] ?? ''));
  return crumbs.map((crumb, index) => {
    if (index === crumbs.length - 1) return crumb;
    const section = shigoNavigationGroups.find((group) =>
      group.activePaths.some((path) => scopedPath(path) === crumb.path),
    );
    if (!section) return crumb;
    const target = groups.find((group) => group.id === section.id)?.entries[0]?.to;
    const segment = { ...crumb };
    delete segment.to;
    return target ? { ...segment, to: scopedPath(target) } : segment;
  });
}
